var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uc-image"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.item.image,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"btn-close",on:{"click":_vm.onDeletePartner}},[_vm._v("×")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-090d0cba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/views/pages/components/uc-image.vue
// module id = 653
// module chunks = 0